let ua: string

if (typeof document !== 'undefined') {
  ua = window.navigator.userAgent || ''
} else {
  ua = ''
}

export const isSunriseClient = /cdfsunrise/i.test(ua)

export const isMiniProgram = /miniProgram/i.test(ua)

export const isAndroid = /android/i.test(ua)

export const isIos = /iphone|ipad|ipod/i.test(ua)

export const isWechat = /micromessenger\/([\d.]+)/i.test(ua)

export const isFeishu = /lark\/([\d.]+)/i.test(ua)

export const isWxWork = /wxwork\/([\d.]+)/i.test(ua) // 企业微信

export const isWeibo = /(weibo).*weibo__([\d.]+)/i.test(ua)

export const isBaidu = /(baiduboxapp)\/([\d.]+)/i.test(ua)

export const isQQ = /qq\/([\d.]+)/i.test(ua)

export const isQQBrowser = /(qqbrowser)\/([\d.]+)/i.test(ua)

export const isUCBrowser = /(ucbrowser)\/([\d.]+)/i.test(ua)

export const isQzone = /qzone\/.*_qz_([\d.]+)/i.test(ua)

export const isQuark = /(quark)\/([\d.]+)/i.test(ua)

// 安卓 chrome 浏览器，包含 原生chrome浏览器、三星自带浏览器、360浏览器以及早期国内厂商自带浏览器
export const isOriginalChrome = /chrome\/[\d.]+ mobile safari\/[\d.]+/i.test(ua) && isAndroid && ua.indexOf('Version') < 0
